<template>
    <div class="mot-color">
        <Navbar />
        <Header :category="'aboutus'" :bannerTitle="bannerTitle" :breadCrumb="breadCrumb" />
        <PrivacyBody />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import PrivacyBody from './PrivacyBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'

    export default {
        name: 'PrivacyMain',
        components: {
            Navbar,
            Header,
            PrivacyBody,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: "MEET<br>OUR TEAM",
                breadCrumb: [{
                    name: this.$t('navbar.menu_5_1')
                }]
            }
        },
    }
</script>

<style scoped>
    .mot-color {
        background-color: #fff;
    }
</style>